import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind classes with proper conflict resolution.
 * Used by all shadcn-style UI primitives.
 */
export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}
